import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { SEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { CheckCircle2, MapPin, Briefcase, GraduationCap, Users, TrendingUp, Award, Upload } from 'lucide-react';
import { sendViaWeb3Forms } from '../services/web3formsService';
import { saveSubmission, type FormateurSubmission } from '../services/databaseService';
export function FormateursPage() {
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData(e.target as HTMLFormElement);
    const data = Object.fromEntries(formData.entries()) as Record<string, string>;
    // Sauvegarder dans la base de données locale
    saveSubmission<FormateurSubmission>({
      type: 'formateur',
      nom: data.nom || '',
      prenom: data.prenom || '',
      email: data.email || '',
      telephone: data.telephone || '',
      domaine: data.domaine || '',
      experience: data.experience || '',
      disponibilite: data.disponibilite || ''
    });
    // Envoyer via Web3Forms (email à contact@adcc.africa)
    const result = await sendViaWeb3Forms({
      type: 'formateur',
      fields: data
    });
    console.log('📋 Formateur submission result:', result);
    setIsLoading(false);
    setSubmitted(true);
    window.scrollTo(0, 0);
  };
  const scrollToForm = () => {
    document.getElementById('application-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  if (submitted) {
    return <Layout data-id="element-1125">
        <div className="min-h-[60vh] flex items-center justify-center bg-gray-50 px-4 py-12" data-id="element-1126">
          <Card className="max-w-md w-full text-center p-8" data-id="element-1127">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1128">
              <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-1129" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1130">
              Candidature envoyée !
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-1131">
              Merci de votre intérêt pour devenir formateur·trice à l'ADCC. Nous
              avons bien reçu votre candidature. Notre équipe recrutement
              l'étudiera avec attention et vous recontactera très prochainement.
            </p>
            <Button onClick={() => window.location.href = '/'} variant="outline" data-id="element-1132">
              Retour à l'accueil
            </Button>
          </Card>
        </div>
      </Layout>;
  }
  return <Layout data-id="element-1133">
      <SEO title="Devenir Formateur - Recrutement ADCC Bénin" description="L'ADCC recrute des formateurs aux métiers de service au Bénin. Formation de formateur gratuite et missions rémunérées à la clé. Postulez maintenant." keywords="recrutement formateur Bénin, emploi formateur Cotonou, formation de formateur gratuite, métiers de service, hôtellerie, nettoyage, insertion professionnelle" url="https://adcc.africa/formateurs" data-id="element-1134" />

      {/* BLOC 1 — HERO */}
      <div className="bg-[#2C3E50] text-white py-20" data-id="element-1135">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1136">
          <h1 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-1137">
            ADCC recrute des formateur·trice·s aux métiers de service au Bénin
          </h1>
          <p className="text-xl md:text-2xl text-blue-200 mb-8 font-medium" data-id="element-1138">
            Formation de formateur 100 % gratuite{' '}
            <span className="mx-2" data-id="element-1139">•</span> Missions rémunérées à la clé
          </p>
          <Button onClick={scrollToForm} size="lg" className="bg-[#1E88E5] hover:bg-[#1976D2] text-white px-8 py-4 text-lg rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-1140">
            Postuler maintenant
          </Button>
        </div>
      </div>

      {/* BLOC 2 — POUR QUI ? */}
      <section className="py-16 bg-white" data-id="element-1141">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1142">
          <div className="text-center mb-12" data-id="element-1143">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1144">
              Pour qui ?
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1145">
              Vous êtes professionnel·le expérimenté·e et souhaitez transmettre
              vos compétences ?
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-1146">
            {[{
            icon: Building2,
            label: 'Hôtellerie & Restauration'
          }, {
            icon: Sparkles,
            label: 'Nettoyage & Hygiène'
          }, {
            icon: Users,
            label: 'Services à la personne'
          }, {
            icon: Briefcase,
            label: 'Insertion professionnelle'
          }, {
            icon: GraduationCap,
            label: "Formation d'adultes"
          }, {
            icon: Heart,
            label: 'Métiers du care'
          }].map((item, idx) => <div key={idx} className="flex items-center p-4 bg-gray-50 rounded-lg border border-gray-100 hover:border-[#1E88E5] transition-colors" data-id="element-1147">
                <div className="p-2 bg-blue-100 rounded-full mr-4 text-[#1E88E5]" data-id="element-1148">
                  <item.icon className="w-6 h-6" data-id="element-1149" />
                </div>
                <span className="font-semibold text-gray-800" data-id="element-1150">
                  {item.label}
                </span>
              </div>)}
          </div>

          <div className="text-center mt-10" data-id="element-1151">
            <p className="text-xl font-medium text-[#1E88E5]" data-id="element-1152">
              Cette formation est faite pour vous.
            </p>
          </div>
        </div>
      </section>

      {/* BLOC 3 — CE QUE VOUS GAGNEZ */}
      <section className="py-16 bg-gray-50" data-id="element-1153">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1154">
          <div className="text-center mb-12" data-id="element-1155">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1156">
              Ce que vous gagnez
            </h2>
            <p className="text-lg text-gray-600" data-id="element-1157">
              Rejoindre l'ADCC, c'est bien plus qu'une mission ponctuelle.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1158">
            {[{
            title: 'Formation gratuite',
            desc: "Bénéficiez d'une formation de formateur certifiante sans frais.",
            icon: GraduationCap
          }, {
            title: 'Missions rémunérées',
            desc: 'Accédez à des opportunités de missions rémunérées régulières.',
            icon: Briefcase
          }, {
            title: 'Revenus complémentaires',
            desc: 'Valorisez votre expertise pour générer un revenu additionnel.',
            icon: TrendingUp
          }, {
            title: 'Impact social',
            desc: "Contribuez concrètement à l'insertion professionnelle au Bénin.",
            icon: Users
          }, {
            title: 'Réseau professionnel',
            desc: "Intégrez une communauté d'experts et de partenaires engagés.",
            icon: Award
          }].map((benefit, idx) => <Card key={idx} className="border-none shadow-md hover:shadow-lg transition-shadow" data-id="element-1159">
                <CardContent className="p-6" data-id="element-1160">
                  <div className="flex items-start" data-id="element-1161">
                    <div className="flex-shrink-0 mt-1" data-id="element-1162">
                      <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-1163" />
                    </div>
                    <div className="ml-4" data-id="element-1164">
                      <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1165">
                        {benefit.title}
                      </h3>
                      <p className="text-gray-600 text-sm" data-id="element-1166">{benefit.desc}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* BLOC 4 — LOCALISATION */}
      <section className="py-12 bg-[#2C3E50] text-white" data-id="element-1167">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1168">
          <div className="inline-flex items-center justify-center p-4 bg-white/10 rounded-full mb-6" data-id="element-1169">
            <MapPin className="w-8 h-8 text-[#1E88E5]" data-id="element-1170" />
          </div>
          <h2 className="text-2xl font-bold mb-2" data-id="element-1171">Localisation</h2>
          <p className="text-xl mb-4" data-id="element-1172">📍 Cotonou, Bénin</p>
          <p className="text-gray-300" data-id="element-1173">
            Disponibilité ponctuelle demandée selon les sessions de formation.
          </p>
        </div>
      </section>

      {/* BLOC 5 — FORMULAIRE */}
      <section id="application-form" className="py-20 bg-white" data-id="element-1174">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1175">
          <Card className="shadow-xl border-t-4 border-t-[#1E88E5]" data-id="element-1176">
            <CardContent className="p-8 md:p-10" data-id="element-1177">
              <div className="text-center mb-8" data-id="element-1178">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-1179">
                  Postuler maintenant
                </h2>
                <p className="text-gray-600 mt-2" data-id="element-1180">
                  Remplissez ce formulaire pour rejoindre notre vivier de
                  formateurs.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1181">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1182">
                  <div data-id="element-1183">
                    <label htmlFor="nom" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1184">
                      Nom *
                    </label>
                    <input type="text" id="nom" name="nom" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-3 border" placeholder="Votre nom" data-id="element-1185" />
                  </div>
                  <div data-id="element-1186">
                    <label htmlFor="prenom" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1187">
                      Prénom *
                    </label>
                    <input type="text" id="prenom" name="prenom" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-3 border" placeholder="Votre prénom" data-id="element-1188" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1189">
                  <div data-id="element-1190">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1191">
                      Email *
                    </label>
                    <input type="email" id="email" name="email" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-3 border" placeholder="votre@email.com" data-id="element-1192" />
                  </div>
                  <div data-id="element-1193">
                    <label htmlFor="telephone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1194">
                      Téléphone *
                    </label>
                    <input type="tel" id="telephone" name="telephone" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-3 border" placeholder="+229..." data-id="element-1195" />
                  </div>
                </div>

                <div data-id="element-1196">
                  <label htmlFor="domaine" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1197">
                    Domaine d'expertise *
                  </label>
                  <select id="domaine" name="domaine" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-3 border bg-white" data-id="element-1198">
                    <option value="" data-id="element-1199">
                      Sélectionnez votre domaine principal...
                    </option>
                    <option value="hotellerie" data-id="element-1200">
                      Hôtellerie / Restauration
                    </option>
                    <option value="nettoyage" data-id="element-1201">Nettoyage / Entretien</option>
                    <option value="hygiene" data-id="element-1202">Hygiène & Sécurité</option>
                    <option value="services" data-id="element-1203">Services à la personne</option>
                    <option value="insertion" data-id="element-1204">
                      Insertion professionnelle / RH
                    </option>
                    <option value="autre" data-id="element-1205">Autre</option>
                  </select>
                </div>

                <div data-id="element-1206">
                  <label htmlFor="experience" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1207">
                    Expérience *
                  </label>
                  <textarea id="experience" name="experience" required rows={4} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-3 border" placeholder="Décrivez brièvement votre expérience professionnelle et vos compétences clés..." data-id="element-1208"></textarea>
                </div>

                <div data-id="element-1209">
                  <label htmlFor="disponibilite" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1210">
                    Disponibilité *
                  </label>
                  <select id="disponibilite" name="disponibilite" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-3 border bg-white" data-id="element-1211">
                    <option value="" data-id="element-1212">Quelle est votre disponibilité ?</option>
                    <option value="semaine" data-id="element-1213">En semaine (journée)</option>
                    <option value="weekend" data-id="element-1214">Le week-end</option>
                    <option value="soiree" data-id="element-1215">En soirée</option>
                    <option value="flexible" data-id="element-1216">Flexible / Variable</option>
                  </select>
                </div>

                <div data-id="element-1217">
                  <label htmlFor="cv" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1218">
                    CV (PDF, Word) *
                  </label>
                  <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md hover:border-[#1E88E5] transition-colors cursor-pointer bg-gray-50" data-id="element-1219">
                    <div className="space-y-1 text-center" data-id="element-1220">
                      <Upload className="mx-auto h-12 w-12 text-gray-400" data-id="element-1221" />
                      <div className="flex text-sm text-gray-600" data-id="element-1222">
                        <label htmlFor="cv-upload" className="relative cursor-pointer bg-white rounded-md font-medium text-[#1E88E5] hover:text-[#1976D2] focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-[#1E88E5]" data-id="element-1223">
                          <span data-id="element-1224">Télécharger un fichier</span>
                          <input id="cv-upload" name="cv" type="file" className="sr-only" accept=".pdf,.doc,.docx" data-id="element-1225" />
                        </label>
                        <p className="pl-1" data-id="element-1226">ou glisser-déposer</p>
                      </div>
                      <p className="text-xs text-gray-500" data-id="element-1227">
                        PDF, DOC jusqu'à 5MB
                      </p>
                    </div>
                  </div>
                </div>

                <div className="pt-4" data-id="element-1228">
                  <Button type="submit" className="w-full text-lg py-6" size="lg" disabled={isLoading} data-id="element-1229">
                    {isLoading ? 'Envoi en cours...' : 'Envoyer ma candidature'}
                  </Button>
                  <p className="text-xs text-gray-500 text-center mt-4" data-id="element-1230">
                    Vos données sont traitées confidentiellement par l'ADCC pour
                    gérer votre candidature.
                  </p>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      </section>
    </Layout>;
}
// Helper icons
function Building2(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1231">
      <rect width="16" height="20" x="4" y="2" rx="2" ry="2" data-id="element-1232" />
      <path d="M9 22v-4h6v4" data-id="element-1233" />
      <path d="M8 6h.01" data-id="element-1234" />
      <path d="M16 6h.01" data-id="element-1235" />
      <path d="M8 10h.01" data-id="element-1236" />
      <path d="M16 10h.01" data-id="element-1237" />
      <path d="M8 14h.01" data-id="element-1238" />
      <path d="M16 14h.01" data-id="element-1239" />
      <path d="M8 18h.01" data-id="element-1240" />
      <path d="M16 18h.01" data-id="element-1241" />
    </svg>;
}
function Sparkles(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1242">
      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" data-id="element-1243" />
      <path d="M5 3v4" data-id="element-1244" />
      <path d="M9 3v4" data-id="element-1245" />
      <path d="M3 5h4" data-id="element-1246" />
      <path d="M3 9h4" data-id="element-1247" />
    </svg>;
}
function Heart(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1248">
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" data-id="element-1249" />
    </svg>;
}